import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { getFailureMessageRxOp } from '@geekbears/gb-ngrx-stack-base';
import { ModalService, NotificationsService } from '@geekbears/ngx-gb-ui-kit';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { map, Observable, Subject, takeUntil, tap } from 'rxjs';

import {
  CompanyActions,
  allCompaniesLoadingSelector,
  deleteCompanyFailureAction,
  deleteCompanySuccessAction,
  getAllCompaniesFailureAction,
} from '@modules/super-admin/company/application';
import {
  allActiveUsersLoadingSelector,
  allActiveUsersSuccessSelector,
  allNotificationsLoadingSelector,
  allCustomersLoadingSelector,
  allCustomersSuccessSelector,
  getAllActiveUsersFailureAction,
  getAllCustomersFailureAction,
  getNotificationsFailureAction,
  getNotificationsSuccessAction,
  markAsReadNotificationFailureAction,
  markAsReadNotificationSuccessAction,
  SuperAdminHomeActions,
} from '@modules/super-admin/superadmin-home/aplication';
import { CompanyModals } from '../../modals';
import { allCompaniesSuccessSelector } from '@modules/super-admin/company/application';
import { Company } from '@modules/super-admin/company/domain';

@Component({
  selector: 'super-admin-home',
  templateUrl: './super-admin.container.html',
  styleUrls: ['./super-admin.container.scss'],
})
export class SuperAdminContainer implements OnInit, OnDestroy, AfterViewInit {
  /**
   * @destroy$ is used to unsubscribe from all subscriptions
   */
  destroy$: Subject<void> = new Subject();
  detailsSelected: string = '';
  currentPage: number = 1;
  itemsPerPages: number = 6;
  companies$: Observable<Company[] | null | undefined>;

  slideIndex = 1;

  activeUsers$: Observable<any>;
  allUsers$: Observable<any>;

  notifications$!: Observable<any>;

  gettingUsers$: Observable<boolean | undefined>;
  gettingActiveUsers$: Observable<boolean | undefined>;
  gettingNotifications$: Observable<boolean | undefined>;

  companiesLoading$: Observable<boolean | undefined>;
  todayDate!: string;
  notifications!: any[];

  dotsCarouselArray: any[] = [];

  currentIndex: number = 1;
  allNotifications: any[] = [];

  constructor(
    private store$: Store,
    private actions$: Actions,
    private modalService: ModalService,
    private notificationService: NotificationsService,
    private router: Router
  ) {
    this.todayDate = moment().format('DD/MM/YYYY');
    this.activeUsers$ = this.store$.select(allActiveUsersSuccessSelector);
    this.allUsers$ = this.store$.select(allCustomersSuccessSelector);
    this.companies$ = this.store$.select(allCompaniesSuccessSelector);
    this.companiesLoading$ = this.store$.select(allCompaniesLoadingSelector);
    this.gettingUsers$ = this.store$.select(allCustomersLoadingSelector);
    this.gettingNotifications$ = this.store$.select(
      allNotificationsLoadingSelector
    );
    this.gettingActiveUsers$ = this.store$.select(
      allActiveUsersLoadingSelector
    );
  }
  ngAfterViewInit(): void {
    // this.currentSlide(1);

    setTimeout(() => {
      this.carouselDots();
    }, 3000);
  }

  ngOnInit(): void {
    this.getAllActiveUsers();
    this.getAllCustomers();
    this.getAllNotifications();
    this.getAllCompanies();
    this.onFailureActions();
    this.actions$
      .pipe(
        ofType(markAsReadNotificationSuccessAction),
        map((action) => {
          if (action) {
            this.notificationService.success(
              'Notification successfully closed',
              {
                duration: 3000,
                icon: 'check-circle',
              }
            );
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();

    this.notifications$ = this.actions$.pipe(
      ofType(getNotificationsSuccessAction),
      map((action) => {
        if (action) {
          this.allNotifications = [...action.notifications.data];
          const notifications = this.split(
            this.formatNotification(this.allNotifications)
          );
          this.notifications = notifications;
          this.formatCarouselDotsContainer(notifications);
          return notifications;
        }
      }),
      tap((action) => {
        if (action.length > 0)
          setTimeout(() => {
            this.showSlides(this.slideIndex);
          }, 1000);
      })
    );

    this.onDeleteCompanySuccess();
  }
  isTheLast() {
    let isEmpty = this.notifications.filter(
      (section) => section.slice.length == 0
    );
    if (isEmpty.length > 0) {
      this.notifications = this.split(this.allNotifications);
      setTimeout(() => {
        if (this.allNotifications.length > 0) {
          this.showSlides(this.notifications.length > 2 ? 1 : 0);
        }
      }, 100);
      this.formatCarouselDotsContainer(this.notifications);
    }
  }

  formatCarouselDotsContainer(notification: any[]) {
    let temp: any = [
      {
        posts: [
          {
            name: '',
            stars: 0,
            description: '',
          },
        ],
      },
    ];

    for (let i = 0; i <= notification.length; i += 5) {
      if (notification.slice(i, i + 5).length > 0) {
        temp.push({ slice: notification.slice(i, i + 5) });
      }
    }
    temp.shift();

    this.dotsCarouselArray = temp;
    return temp;
  }

  formatNotification(notifications: any[]) {
    return notifications.map((element) => {
      const newElement = { ...element };
      newElement.content = element.content.replace(
        'Tap to see more details',
        ''
      );
      newElement.createdAt = moment(element.createdAt).format('llll');
      return newElement;
    });
  }

  onDeleteCompanySuccess() {
    this.actions$
      .pipe(
        ofType(deleteCompanySuccessAction),
        map((action) => {
          this.getAllCompanies();
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  pageChanged(event: any) {
    this.currentPage = event;
  }

  // Next/previous controls
  plusSlides(n: any) {
    this.showSlides((this.slideIndex += n));
  }

  // Thumbnail image controls
  currentSlide(n: any) {
    this.showSlides((this.slideIndex = n));
  }

  showSlides(n: any) {
    let i;
    let slides: any = document.getElementsByClassName('mySlides');
    let dots = document.getElementsByClassName('dot');
    if (!slides || slides.length === 0) {
      return;
    }
    if (n > slides.length) {
      this.slideIndex = 1;
    } else if (n < 1) {
      this.slideIndex = slides.length;
    } else {
      this.slideIndex = n;
    }

    for (i = 0; i < slides.length; i++) {
      if (slides[i]) {
        slides[i].style.display = 'none';
      }
    }
    for (i = 0; i < dots.length; i++) {
      if (dots[i]) {
        dots[i].className = dots[i].className.replace(' active', '');
      }
    }
    if (slides[this.slideIndex - 1]) {
      slides[this.slideIndex - 1].style.display = 'block';
    }
    if (dots[this.slideIndex - 1]) {
      dots[this.slideIndex - 1].className += ' active';
    }
  }

  split(not: any) {
    let temp: any = [
      {
        posts: [
          {
            name: '',
            stars: 0,
            description: '',
          },
        ],
      },
    ];

    for (let i = 0; i <= not.length; i += 4) {
      if (not.slice(i, i + 4).length > 0) {
        temp.push({ slice: not.slice(i, i + 4) });
      }
    }
    temp.shift();

    return temp;
  }

  splitNotificationsDots() {}
  closeNotification(id: string) {
    this.popNotifications(id);
    this.isTheLast();

    this.store$.dispatch(
      SuperAdminHomeActions.markAsReadNotification({
        notificationId: id,
      })
    );
  }

  popNotifications(notificationsId: string) {
    this.allNotifications.splice(+notificationsId, 1);

    this.notifications.map((element) => {
      return element.slice.findIndex((elemtn: any, index: any) => {
        if (elemtn._id == notificationsId) {
          element.slice.splice(index, 1);

          return true;
        } else {
          return false;
        }
      });
    });
    this.formatCarouselDotsContainer(this.notifications);
  }

  deleteCompany(company: Company) {
    this.modalService.open(CompanyModals, {
      data: {
        modalType: 'deleteCompany',
        company: company,
      },
    });
  }
  viewDetails() {}

  /**
   * All Customers
   */
  getAllCustomers() {
    this.store$.dispatch(SuperAdminHomeActions.getAllCustomers());
  }
  /**
   * All Active Users
   */
  getAllActiveUsers() {
    this.store$.dispatch(SuperAdminHomeActions.getAllActiveUsers());
  }
  /**
   * All Notifications
   */
  getAllNotifications() {
    this.store$.dispatch(
      SuperAdminHomeActions.getNotifications({
        populate: ['_user'],
        sort: '-createdAt',
        filter: {
          readAt: null,
        },
      })
    );
  }
  /**
   * All Companies
   */
  getAllCompanies() {
    this.store$.dispatch(
      CompanyActions.getAllCompanies({
        sort: '-createdAt',
        populate: ['parentCompany'],
      })
    );
  }
  companyDetails(companyId: string) {
    this.router.navigateByUrl(`dashboard/company/details/${companyId}`);
  }
  onFailureActions() {
    this.actions$
      .pipe(
        ofType(
          getAllCustomersFailureAction,
          getAllActiveUsersFailureAction,
          getNotificationsFailureAction,
          getAllCompaniesFailureAction,
          markAsReadNotificationFailureAction,
          deleteCompanyFailureAction
        ),
        map((action) => {
          return action.failure;
        }),
        getFailureMessageRxOp(),
        tap((errorMessage) => {
          if (errorMessage) {
            this.notificationService.error(errorMessage, {
              duration: 5000,
              icon: 'alert-outline',
            });
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  navigateToCompanyDetails(companyId: string) {
    this.router.navigateByUrl(`dashboard/company/details/${companyId}`);
  }

  carouselDots() {
    const slidesContainer: any = document.getElementById('slides-container');
    const slide = document.querySelector('.slide');
    const prevButton = document.getElementById('slide-arrow-prev');
    const nextButton = document.getElementById('slide-arrow-next');

    nextButton?.addEventListener('click', () => {
      const slideWidth: any = slide?.clientWidth;
      slidesContainer.scrollLeft += slideWidth;
      this.currentIndex = this.currentIndex + 1;
    });

    prevButton?.addEventListener('click', () => {
      const slideWidth: any = slide?.clientWidth;
      slidesContainer.scrollLeft -= slideWidth;
      this.currentIndex = this.currentIndex - 1;
    });
  }
  toTitleCase(industry: string) {
    if (industry)
      return industry
        .replace(/\w\S*/g, function (txt: string) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        })
        .toString()
        .replace(/-/g, ' ');
    else return 'N/A';
  }
}
